import { useMemo } from 'react';
import { SchemaFormFields } from '@mews-commander/form';
import { FinancialDocumentPdfTemplateType } from '@mews-commander/data-access';
import { useCurrentEnterprise } from '@mews-commander/legacy-entities/src/enterprise';
import { useLanguageOptions } from '../hooks/useLanguageOptions';
import { sendReminderSchema } from '../schema';
import { getSendReminderFormDefinition } from './getSendReminderFormDefinition';

interface SendReminderFormContentProps {
    allowedInvoiceTemplateTypes: FinancialDocumentPdfTemplateType[];
}

export const SendReminderFormContent = ({ allowedInvoiceTemplateTypes }: SendReminderFormContentProps) => {
    const { defaultLanguageCode } = useCurrentEnterprise();
    const { languages } = useLanguageOptions();

    const sendReminderFormDefinition = useMemo(
        () =>
            getSendReminderFormDefinition({
                allowedInvoiceTemplateTypes,
                defaultLanguageCode,
                languages,
            }),
        [allowedInvoiceTemplateTypes, defaultLanguageCode, languages]
    );

    return <SchemaFormFields schema={sendReminderSchema} formDefinition={sendReminderFormDefinition} />;
};
